import React from 'react'

const BANNER_COLORS = ['#556B2F', '#6B8E23', '#E65100']

function StoryCard({ story, colorIndex = 0, onViewStory }) {
  const bannerColor = BANNER_COLORS[colorIndex % BANNER_COLORS.length]
  const sharer = story.sharer || {}

  const handleClick = () => {
    if (onViewStory) onViewStory(story)
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return null
    const d = new Date(dateStr)
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  }

  const renderMedia = () => {
    if (story.thumbnailUrl) {
      if (story.hasVideo) {
        const videoSrc = story.videoDirectUrl || story.thumbnailUrl
        return (
          <div className="relative w-full h-full">
            <video
              src={`${videoSrc}#t=0.5`}
              className="w-full h-full object-cover"
              muted
              playsInline
              preload="auto"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-10 h-10 rounded-full bg-black/50 flex items-center justify-center">
                <svg className="w-5 h-5 text-white ml-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                </svg>
              </div>
            </div>
          </div>
        )
      }
      return <img src={story.thumbnailUrl} alt="" className="w-full h-full object-cover" />
    }
    if (story.hasAudio) {
      return (
        <div className="w-full h-full bg-gray-100 flex items-center justify-center">
          <span className="text-3xl">🎵</span>
        </div>
      )
    }
    if (story.preview) {
      return (
        <div className="w-full h-full bg-[#F8F6F0] px-4 py-3 overflow-hidden">
          <p className="font-serif text-gray-600 text-sm leading-relaxed line-clamp-4">
            {story.preview}
          </p>
        </div>
      )
    }
    return (
      <div className="w-full h-full bg-gray-50 flex items-center justify-center">
        <span className="text-gray-400 text-sm font-serif">No media</span>
      </div>
    )
  }

  const commentCount = story.engagement?.commentCount || 0
  const reactionCount = story.engagement?.reactionCount || 0

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col">
      {/* Colored banner with title */}
      <div
        className="px-4 py-3"
        style={{ backgroundColor: bannerColor }}
      >
        <h3 className="font-serif font-bold text-white text-base leading-snug line-clamp-2">
          {story.title || 'Untitled Story'}
        </h3>
      </div>

      {/* Media area */}
      <div className="aspect-video overflow-hidden">
        {renderMedia()}
      </div>

      {/* Meta section */}
      <div className="px-4 py-3 flex-1">
        <div className="flex items-center gap-2 mb-1">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
            style={{ backgroundColor: sharer.avatarColor || '#6B7F4A' }}
          >
            {sharer.initials || sharer.firstName?.[0]?.toUpperCase() || '?'}
          </div>
          <div className="min-w-0">
            <p className="font-serif text-sm text-gray-800 truncate">
              <span className="font-semibold">{sharer.firstName || 'Someone'}</span>
              {' '}shared
            </p>
            <p className="font-serif text-xs text-gray-500">
              {formatDate(story.sharedAt)}
              {story.location && (
                <span className="text-orange-600"> · 📍 {story.location}</span>
              )}
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="px-4 py-3 border-t border-gray-100 flex items-center justify-between">
        <button
          onClick={handleClick}
          className="bg-fb-olive hover:bg-fb-olive/90 text-white font-serif font-semibold text-sm px-4 py-1.5 rounded-lg transition-colors"
        >
          View & Comment
        </button>
        <div className="flex items-center gap-2">
          {story.familyName && (
            <span className="bg-[#556B2F]/10 text-[#556B2F] text-[11px] font-semibold px-2 py-0.5 rounded-full">
              {story.familyName}
            </span>
          )}
          {(commentCount > 0 || reactionCount > 0) && (
            <span className="font-serif text-xs text-gray-500">
              {commentCount > 0 && `${commentCount} comment${commentCount !== 1 ? 's' : ''}`}
              {commentCount > 0 && reactionCount > 0 && ' · '}
              {reactionCount > 0 && `${reactionCount} reaction${reactionCount !== 1 ? 's' : ''}`}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default StoryCard
